import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '../actions/user'
import { AUTH_LOGOUT } from '../actions/auth'
import Vue from 'vue'
import Api from '@/config/Api'


const state = { status: '', profile: {} }

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name,
}

const actions = {
  [USER_REQUEST]: ({commit, dispatch}) => {
    commit(USER_REQUEST)
    Api().get('/api/profile')
      .then(resp => {
        console.log("/api/profile GOOD...",resp);
        commit(USER_SUCCESS, resp.data)
      })
      .catch(resp => {
        console.log("/api/profile FAIL...");
        commit(USER_ERROR)
        // if resp is unauthorized, logout, too
        dispatch(AUTH_LOGOUT)
      })
  },
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
    console.log("[user] AUTH_REQUEST");
  },
  [USER_SUCCESS]: (state, resp) => {
    console.log("[user] USER_SUCCESS");
    state.status = 'success'
    Vue.set(state, 'profile', resp)
    /* console.log("resp",resp);
    console.log("USER_SUCCESS");
    console.log("state =",state);
    console.log("state.profileName =", state.profile.name); */
  },
  [USER_ERROR]: (state) => {
    console.log("[user] USER_ERROR");
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    console.log("[user] AUTH_LOGOUT");
    state.profile = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js